export default __webpack_public_path__ + "static/media/a016-4.43cbb3e6.jpg";